"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["hasVisibility"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TRANSITION_TIME = 170;

var StyledBackdrop = /*#__PURE__*/_styledComponents["default"].div.withConfig({
  displayName: "Backdrop__StyledBackdrop",
  componentId: "sc-1hau3s6-0"
})(["position:fixed;top:0;left:0;width:100vw;height:100vh;z-index:1;background-color:", ";opacity:0;transition:opacity ", "ms,transform 0ms;&.fade-in-enter-done{opacity:0.75;}"], function (p) {
  return p.theme.tokens.colorPaletteGray900;
}, TRANSITION_TIME);

var Backdrop = function Backdrop(_ref) {
  var hasVisibility = _ref.hasVisibility,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isHidden = _useState2[0],
      setHidden = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!hasVisibility) {
      setTimeout(function () {
        setHidden(true);
      }, TRANSITION_TIME);
    } else {
      setHidden(false);
    }
  }, [hasVisibility]);
  return /*#__PURE__*/_react["default"].createElement(StyledBackdrop, (0, _extends2["default"])({}, props, {
    style: {
      display: isHidden ? 'none' : 'block'
    }
  }));
};

Backdrop.propTypes = {
  hasVisibility: _propTypes.bool
};
var _default = Backdrop;
exports["default"] = _default;